import { Component } from '@angular/core';

import { MonitoringService } from '@core/services/monitoring.service';
import { ReportAbstract } from '@features/reports/abstracts/report.abstract';
import { ReportsService } from '@features/reports/services/reports.service';
import { Report } from '@shared/enums/report.enum';

interface RefixSummary {
  adviser: string;
  clientFullName: string;
  fixedMaturityDate: string;
  ioMaturityDate: string;
  interestRate: string;
  provider: string;
}

@Component({
  templateUrl: './refixes.component.html'
})
export class RefixesReportComponent extends ReportAbstract<RefixSummary> {
  title = 'Refixes';
  reportName = Report.Refixes;
  contactBaseUrl = '/Contacts/Individual/';
  csvHeaders = [
    {
      label: 'Adviser',
      value: 'adviser'
    },
    {
      label: 'First Name',
      value: 'firstName'
    },
    {
      label: 'Last Name',
      value: 'lastName'
    },
    {
      label: 'Lender',
      value: 'provider'
    },
    {
      label: 'Product Name',
      value: 'product'
    },
    {
      label: 'Loan Amount',
      value: 'loanAmount'
    },
    {
      label: 'Interest Rate',
      value: 'interestRate'
    },
    {
      label: 'Repayment Type',
      value: 'repaymentType'
    },
    {
      label: 'Interest Type',
      value: 'interestType'
    },
    {
      label: 'Fixed Rate Term',
      value: 'fixedRateTerm'
    },
    {
      label: 'Fixed Maturity Date',
      value: 'fixedMaturityDate'
    },
    {
      label: 'IO term',
      value: 'ioTerm'
    },
    {
      label: 'IO Maturity Date',
      value: 'ioMaturityDate'
    }
  ];

  constructor(
    reportsService: ReportsService,
    monitoringService: MonitoringService
  ) {
    super(Report.Refixes, reportsService, monitoringService);
  }
}
